import { BackgroundCheckColumns } from '@/backend/features/background-check/shared';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { ExtendedAccountFilterData } from '@/ui/features/contact-management/AccountsPanel/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { Filter } from '@juvare/platform-shared/features/storage';
import { endOfDay, startOfDay } from 'date-fns';

export function mapBackgroundCheckFilter(
    enabledTypes: BackgroundCheckType[],
    filterData: ExtendedAccountFilterData,
    expiringOnlyFilters: Filter<BackgroundCheckColumns>[],
) {
    const defaultFilters: Filter<BackgroundCheckColumns>[] = [
        {
            column: 'type',
            op: 'in',
            value: enabledTypes,
        },
        {
            column: 'accountId',
            op: 'in',
            subFilter: { entity: accountEntityName, filter: [{ column: 'systemStatus', op: '=', value: 'active' }] },
        },
    ];

    const filter: Filter<BackgroundCheckColumns>[] = [...defaultFilters];

    if (filterData.backgroundCheckStatus) {
        filter.push({
            column: 'status',
            op: 'in',
            value: filterData.backgroundCheckStatus,
        });
    }

    if (filterData.backgroundCheckUpdatedAt?.from && filterData.backgroundCheckUpdatedAt?.to) {
        const from = startOfDay(filterData.backgroundCheckUpdatedAt.from).getTime();
        const to = endOfDay(filterData.backgroundCheckUpdatedAt.to).getTime();

        filter.push({
            column: 'updatedAt',
            op: '<=',
            value: to,
        });
        filter.push({
            column: 'updatedAt',
            op: '>=',
            value: from,
        });
    }

    if (filterData.backgroundCheckType) {
        filter.push({
            column: 'type',
            op: '=',
            value: filterData.backgroundCheckType,
        });
    }

    if (expiringOnlyFilters.length) {
        filter.push(...expiringOnlyFilters);
    }

    return { filter, defaultFilters };
}
